module.exports = __webpack_public_path__ + "static/media/web1.241f84c0.jpg";